export default {"src":"/_next/static/media/report.50d98dd7.svg","height":213,"width":190,"blurWidth":0,"blurHeight":0};